// Show Variant wise badge on Image Gallery
document.addEventListener('variant:change', function(event) {
  const variant = event.detail.variant;
  const variantId = variant.id;
  const js_variant_based_sales = document.querySelectorAll('.js_variant_based_sale');
  if(js_variant_based_sales.length > 0){
    js_variant_based_sales.forEach(wrapper=>{
      const allVariantSaleBadges = wrapper.querySelectorAll('.js_variantsale__badge');
      if(allVariantSaleBadges.length > 0){
        allVariantSaleBadges.forEach(variant_sale=>{
          const badgeVariantId = Number(variant_sale.getAttribute('data-variant-id'));
          if(badgeVariantId === variantId){
            variant_sale.removeAttribute('hidden');
          } else{
            variant_sale.setAttribute('hidden', true);
          }
        })
      }
    })
  }
})



document.addEventListener("DOMContentLoaded", function(event) {
    const shippingEls = document.querySelectorAll('.shipping-el');

    shippingEls.forEach(shippingel => {
      console.log('shippingel', getComputedStyle(shippingel).color);
      if (getComputedStyle(shippingel).color === "rgb(255, 0, 0)") {
        // Look for the closest <product-form> element within the same parent container
        const closestProductForm = shippingel.closest('.product-info-inner')?.querySelector('product-form');
        
        // If a <product-form> was found, hide it
        if (closestProductForm) {
          closestProductForm.style.display = 'none';
        }
      }
    });
});

document.addEventListener('variant:change', function(event) {
  console.log(event);
  const variant = event.detail.variant;
  console.log(variant);
  renderAvailability(variant);
  renderAdditionalInformation(variant);
  toggleCountdownBox(variant);
});

const renderAvailability = (variant) => {
  if(typeof variantMetafields !== 'undefined' && variantMetafields !== null){
     const metafieldValue = variantMetafields[variant.id];
    if (metafieldValue) {
      console.log('Metafield Value:', metafieldValue);
      // Use the metafield value as needed
      document.querySelector('.shipping-el').innerHTML = metafieldValue.label;
      document.querySelector('.shipping-el').style.color = metafieldValue.color;
      if(metafieldValue.color == "#ff0000"){
        document.querySelector('product-form').style.display = 'none';
      }else{
        document.querySelector('product-form').style.display = 'block';
      }
    } else {
      console.log('Metafield not found for this variant.');
    } 
  }else{
      if(window["variantMetafields" + variant.featured_image.product_id]){
        const metafieldValue = window["variantMetafields" + variant.featured_image.product_id][variant.id];
        if (metafieldValue) {
          console.log('Metafield Value:', metafieldValue);
          // Use the metafield value as needed
          event.srcElement.closest(".product-info-inner").querySelector('.shipping-el').innerHTML = metafieldValue.label;
          event.srcElement.closest(".product-info-inner").querySelector('.shipping-el').style.color = metafieldValue.color;
        } else {
          console.log('Metafield not found for this variant.');
        } 
      }
  }

  const shippingEls = document.querySelectorAll('.shipping-el');

    shippingEls.forEach(shippingel => {
      console.log('shippingel', getComputedStyle(shippingel).color);
      if (getComputedStyle(shippingel).color === "rgb(255, 0, 0)") {
        // Look for the closest <product-form> element within the same parent container
        const closestProductForm = shippingel.closest('.product-info-inner')?.querySelector('product-form');
        
        // If a <product-form> was found, hide it
        if (closestProductForm) {
          closestProductForm.style.display = 'none';
        }
      }else{
        // Look for the closest <product-form> element within the same parent container
        const closestProductForm = shippingel.closest('.product-info-inner')?.querySelector('product-form');
        
        // If a <product-form> was found, hide it
        if (closestProductForm) {
          closestProductForm.style.display = 'block';
        }
      }
    });
};

const renderAdditionalInformation = (variant) => {
  if(typeof allFrontendMetafields !== 'undefined' && allFrontendMetafields !== null){
    console.log('allFrontendMetafields', allFrontendMetafields);
    const element = document.querySelector('.additional_information');
    const escapedHTML = allFrontendMetafields[variant.id]?.additional_information;
    if(escapedHTML){
      const parser = new DOMParser();
      const parsedDoc = parser.parseFromString(escapedHTML, 'text/html');
      const realHTML = parsedDoc.body.textContent;
      if(element){
        element.innerHTML = realHTML; 
        element.style.display = "flex";
      }
    }else{
      if(element)
        element.style.display = "none";
    }
  }
};

const toggleCountdownBox = (variant) => {
  if(typeof variantMetafields !== 'undefined' && variantMetafields !== null){
    const metafieldValue = variantMetafields[variant.id]?.label ?  variantMetafields[variant.id]?.label : "";
    if (!variant.available) {
      const countdownBoxes = document.querySelectorAll('[data-hidesoldout="true"]'); // Select all matching elements
      countdownBoxes.forEach(box => {
        box.style.display = 'none'; // Hide each box
      });
    } else if (!metafieldValue.includes('in 1-3 Werktagen bei dir')){
        const countdownBoxes = document.querySelectorAll('[data-hidesoldout="true"]');
        countdownBoxes.forEach(box => {
          box.style.display = 'none'; // Hide each box
        });
    } else {
      const countdownBoxes = document.querySelectorAll('[data-hidesoldout="true"]'); // Select all matching elements
      countdownBoxes.forEach(box => {
        box.style.display = ''; // Reset the display style to show them (default behavior)
      });
    }
  }
};

const current_json_t = document.querySelector('meta[name="taggrs-current"]').content;
const current_t = JSON.parse(current_json_t);
document.addEventListener('DOMContentLoaded', toggleCountdownBox(current_t));
